import {
    Directive,
    Input,
    OnChanges,
    SimpleChanges,
    inject
} from "@angular/core";
import { NgControl } from "@angular/forms";
import { asapScheduler } from "rxjs";

/*
 A directive for disabling controls in the template without receiving warnings such as
 "It looks like you're using the disabled attribute with a reactive form directive. If you set disabled to true"
*/
@Directive({ selector: "[raskDisabledControl]" })
export class DisabledControlDirective implements OnChanges {
    @Input() raskDisabledControl = false;

    private readonly ngControl = inject(NgControl);

    ngOnChanges(_changes: SimpleChanges): void {
        asapScheduler.schedule(() => {
            if (this.raskDisabledControl) {
                this.ngControl.control?.disable({ onlySelf:true,
                    emitEvent:false });
            } else {
                this.ngControl.control?.enable({ onlySelf:true,
                    emitEvent:false });
            }
        });
    }
}
